// NovaHome — Scripts personalizados (mt = "mi tienda")
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCarruseles();
});

function initReveal() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.mtDelay || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

function initCarruseles() {
  var wraps = document.querySelectorAll('[data-mt-carrusel]');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('.mt-carrusel');
    var prev = wrap.querySelector('[data-mt-prev]');
    var next = wrap.querySelector('[data-mt-next]');
    if (!track || !prev || !next) return;

    function paso() {
      var item = track.querySelector('.mt-carrusel-item');
      return item ? item.getBoundingClientRect().width + 20 : 280;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -paso(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: paso(), behavior: 'smooth' });
    });
  });
}
